import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';

export const getFacebookConversations = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const getFacebookConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/${conversation_id}`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const searchFacebookConversation = async (
  organization_id: string,
  search_key: string,
) => {
  let token = await getAuthToken();

  if (!token?.success || !token.data) {
    return { success: false, data: 'Token does not exist' };
  }

  const headers = {
    Authorization: `Bearer ${token.data}`,
  };

  try {
    const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/?search=${encodeURIComponent(
      search_key,
    )}`;

    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status < 400) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, data: error };
  }
};

export const deleteFacebookConversation = async (
  organization_id: any,
  conversation_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/${conversation_id}/`;
        const response = await axios.delete(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const getFacebookMessages = async (
  conversation_id: any,
  organization_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/${conversation_id}/messages`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the data:', error);
    return { success: false, data: undefined };
  }
};

export const sendFacebookMessage = async (
  conversation_id: any,
  text: string,
  organization_id: string,
  attachment?: File | null,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers: Record<string, string> = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-conversations/${conversation_id}/messages/send/`;
        if (attachment) {
          const payload = new FormData();
          payload.append('text', text || '');
          payload.append('attachment', attachment);
          const response = await axios.post(endpoint, payload, { headers });
          if (response.status >= 200 && response.status <= 400) {
            return { success: true, data: response?.data };
          } else {
            console.error('Message send failed:', response, response.data);
            return { success: false, data: response?.data };
          }
        } else {
          headers['Content-Type'] = 'application/json';
          const response = await axios.post(endpoint, { text }, { headers });
          if (response.status >= 200 && response.status <= 400) {
            return { success: true, data: response?.data };
          } else {
            console.error('Message send failed:', response, response.data);
            return { success: false, data: response?.data };
          }
        }
      } catch (error) {
        console.error('Send message error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error while sending message:', error);
    return { success: false, data: undefined };
  }
};

export const disconnectFacebookPage = async (
  organization_id: any,
  profile_id: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      const headers = { Authorization: 'Bearer ' + token.data };
      const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${profile_id}/`;
      const response = await axios.delete(endpoint, { headers });
      console.log('facebook profile response', response);

      if (response.status >= 200 && response.status < 405) {
        return { success: true, data: null };
      } else {
        console.error('Failed to fetch user profile:', response);
        return { success: false, data: response.data };
      }
    } else {
      return { success: false, data: 'Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error fetching profile:', error);
    return { success: false, data: error };
  }
};

export const getFacebookProfile = async (organization_id: any) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status < 400) {
          if (response.data && Object.keys(response.data).length > 0) {
            return { success: true, data: response.data };
          } else {
            console.warn(
              'No Facebook account data found for this organization',
            );
            return { success: false, data: null };
          }
        } else {
          console.error('Failed to fetch user profile:', response);
          return { success: false, data: response.data };
        }
      } catch (error) {
        console.error('Profile fetch error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, data: undefined };
  }
};

export const connectFacebookPageToCRM = async (
  page_id: any,
  access_token: any,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
        'Content-Type': 'application/json',
      };
      try {
        const endpoint = `${baseUrl}/core/facebook/pages/connect`;
        const response = await axios.post(
          endpoint,
          {
            page_id,
            access_token,
          },
          { headers },
        );
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Connect failed:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('Connect error:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error:', error);
    return { success: false, data: undefined };
  }
};

export const toggleFacebookAiChatResponses = async (
  organization_id: any,
  page_id: any,
  enabled: boolean,
) => {
  let token = await getAuthToken();
  try {
    if (token?.success && token.data) {
      let header_token = 'Bearer ' + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/facebook-account/${page_id}/toggle-ai-chats/`;
        const response = await axios.post(endpoint, { enabled }, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        }
        return { success: false, data: response?.data };
      } catch (error) {
        console.error('Unexpected error (toggle chat AI):', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred:', error);
    return { success: false, data: undefined };
  }
};
